/* tslint:disable:import-spacing no-inferrable-types variable-name align no-trailing-whitespace */

import {SchemaSpecification} from './schema.specification';
import {WorkBlock, WorkType} from '@/models/scenario/work.block';
import {Period}              from '@/util/period';

export class WorkBlockSchema extends SchemaSpecification {

  constructor() {

    super();

    this.jsonSpec = `{
 "workblocks": {
  "schema": {
   "fields": [
    {
     "name": "work_block_id",
     "title": "client generated id for this work_block, must be unique within model",
     "type": "integer",
     "col": 1,
     "constraints": {
      "required": true
     }
    },
    {
     "name": "from_dp",
     "title": "ID of Decision point on West end (high MP) of work zone",
     "type": "integer",
     "col": 2,
     "constraints": {
      "required": true
     }
    },
    {
     "name": "to_dp",
     "title": "ID of Decision point on East end (low MP) of work zone",
     "type": "integer",
     "col": 3,
     "constraints": {
      "required": true
     }
    },
    {
     "name": "active_days",
     "title": "LIST of integer simulation days, where there is work fitting this pattern",
     "type": "integer array",
     "col": 4,
     "constraints": {
      "required": true
     }
    },
    {
     "name": "daily_start",
     "title": "Time, P00DT12H00M00s, time of day at which to start the work every day. Day is always 0.",
     "type": "string",
     "col": 5,
     "constraints": {
      "required": true
     }
    },
    {
     "name": "daily_duration",
     "title": "Time, P00DT12H00M00s, duration of work.  Must be less than 24 hours.",
     "type": "string",
     "col": 6,
     "constraints": {
      "required": true
     }
    },
    {
     "name": "logic_type",
     "title": "The type of logic to apply",
     "type": "string",
     "col": 7,
     "constraints": {
      "required": true,
      "enum": [
       "megablock",
       "construction"
      ]
     }
    },
    {
     "name": "name",
     "title": "user label",
     "type": "string",
     "col": 8
    },
    {
     "name": "description",
     "title": "user description",
     "type": "string",
     "col": 9
    }
   ],
   "primaryKey": "tag"
  },
  "dataType": "object",
  "data": [
  ]
 }
}`;

    super.cache();
  }

  /** convert the given object to data table row, only properties that match field names will be created. */
  public toRow(object: any): any[] {

    const block: WorkBlock = object as WorkBlock;

    /* assume object is a WorkBlock and create an object that has fields compatible with this schema */

    const proxy: any = {
      work_block_id:  block._id,
      from_dp:        block._from._id,
      to_dp:          block._to._id,
      active_days:    block._days,
      daily_start:    Period.toString(block._start),
      daily_duration: Period.toString(block._duration),
      logic_type:     (block._type === WorkType.MEGABLOCK) ? 'megablock' : 'construction',
      name:           block._name,
      description:    block._description
    };

    /* now convert that */

    return super.toRow(proxy);
  }

  /** helper to insert work blocks into a scenario workblocks section, returns the full object, ready to be saved. */
  render(items: WorkBlock[]): any {

    /* create the data table */

    const d = this.dataTable(items);

    /* insert */

    const w: any = this.findObject('workblocks', this.schemaObj);

    if (w === null) {

      this.lastError = `(render) problems finding workblocks section: ${this.lastError}`;

      return null;
    }

    w['data'] = d;

    /* pass back the full rendered version, this version can be given to JSON.stringify() to save to file. */

    return this.schemaObj;
  }

}
